import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SessionState {
  id: string
  name: string
  email: string
  picture: string
  token_use: string
  exp: number
  id_token: string
  access_token: string
  refresh_token: string
  code: string
  state: string
}

const initialState: SessionState = {
  id: '',
  name: '',
  email: '',
  picture: '',
  token_use: '',
  exp: 0,
  id_token: '',
  access_token: '',
  refresh_token: '',
  code: '',
  state: ''
}

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSession: (state: SessionState, action: PayloadAction<SessionState>) => {
      return { ...state, ...action.payload };
    },
    clearSession: (_state: SessionState) => {
      return { ...initialState };
    },
  },
})

export const hasSession = (state: SessionState): boolean => {
  return state.id !== '';
};

export const { setSession, clearSession } = sessionSlice.actions
export default sessionSlice.reducer
